// src/components/theme/index.js

import { ThemeBarSettings } from './ThemeBar';
import { ThemeLineSettings } from './ThemeLine';
import { ThemeValueSettings } from './ThemeValue';
import { ThemeTextSettings } from './ThemeText';
import { ThemeTimeSettings } from './ThemeTime';
import { ThemeImageIndicatorSettings } from './ThemeImageIndicator';
import { ThemeRecIndicatorSettings } from './ThemeRecIndicator';
import { ThemeSpecialIndicatorSettings } from './ThemeSpecialIndicator';
import { ThemeSpeedLimiterIndicatorSettings } from './ThemeSpeedLimiterIndicator';
import { ThemeNavDirectionSettings } from './ThemeNavDirection';
import { ThemeNavMapSettings } from './ThemeNavMap';
import { ThemeNavCompassSettings } from './ThemeNavCompass';
import { ThemeNavInstructionSettings } from './ThemeNavInstruction';
import { ThemeImageCustomSettings } from './ThemeImageCustom';


export { default as ThemeBar } from './ThemeBar';
export { default as ThemeLine } from './ThemeLine';
export { default as ThemeValue } from './ThemeValue';
export { default as ThemeText } from './ThemeText';
export { default as ThemeTime } from './ThemeTime';
export { default as ThemeImageIndicator } from './ThemeImageIndicator';
export { default as ThemeRecIndicator } from './ThemeRecIndicator';
export { default as ThemeSpecialIndicator } from './ThemeSpecialIndicator';
export { default as ThemeSpeedLimiterIndicator } from './ThemeSpeedLimiterIndicator';
export { default as ThemeNavMap } from './ThemeNavMap';
export { default as ThemeNavDirection } from './ThemeNavDirection';
export { default as ThemeNavCompass } from './ThemeNavCompass';
export { default as ThemeNavInstruction } from './ThemeNavInstruction';
export { default as ThemeImageCustom } from './ThemeImageCustom';


export const SettingsComponents = {
    value: ThemeValueSettings,
    time: ThemeTimeSettings,
    barGraph: ThemeBarSettings,
    line: ThemeLineSettings,
    text: ThemeTextSettings,
    imageIndicator: ThemeImageIndicatorSettings,
    recIndicator: ThemeRecIndicatorSettings,
    speedLimiterIndicator: ThemeSpeedLimiterIndicatorSettings,
    specialIndicator: ThemeSpecialIndicatorSettings,
    navMap: ThemeNavMapSettings,
    navDirection: ThemeNavDirectionSettings,
    navCompass: ThemeNavCompassSettings,
    navInstruction: ThemeNavInstructionSettings,
    imageCustom: ThemeImageCustomSettings
};
